/** Saved when lifestyle fields are left blank so Discover profiles aren't empty. */
export const LIFESTYLE_DEFAULT = "Prefer not to say";

export function withLifestyleDefaults({
  drinking = "",
  smoking = "",
  workout = "",
  religion = "",
} = {}) {
  const pick = (v) => {
    const s = typeof v === "string" ? v.trim() : "";
    return s || LIFESTYLE_DEFAULT;
  };
  return {
    drinking: pick(drinking),
    smoking: pick(smoking),
    workout: pick(workout),
    religion: pick(religion),
  };
}

/** Display helper — show saved value or the soft default. */
export function displayLifestyleValue(value) {
  const s = typeof value === "string" ? value.trim() : "";
  return s || LIFESTYLE_DEFAULT;
}
